import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { SundayFirstNativeDateAdapter } from './sunday-first-native-date-adapter';

export const MATERIAL_COMPONENTS = [
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatCheckboxModule,
  MatMenuModule,
  MatSelectModule,
  MatInputModule,
  MatFormFieldModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  MatTimepickerModule,
  DragDropModule,
  MatNativeDateModule,
  MatChipsModule,
  MatIconModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatButtonToggleModule,
  MatTabsModule,
  MatProgressBarModule,
  MatSnackBarModule,
  MatSliderModule,
  MatSortModule,
  CdkAccordionModule,
  TextFieldModule,
];

@NgModule({
  imports: [MATERIAL_COMPONENTS],
  exports: [MATERIAL_COMPONENTS],
  providers: [{ provide: DateAdapter, useClass: SundayFirstNativeDateAdapter, deps: [MAT_DATE_LOCALE] }],
})
export class SharedUiMaterialModule {}
